import type { SubmitHandler } from 'react-hook-form';
import { useState } from 'react';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiCreatePollResponseBody } from '~/lib/api/modules/Polls';
import type { IUseCreatePollMutationValues } from '~/lib/api/modules/Polls/hooks/useCreatePollMutation';
import type { IPollFormValues } from './PollForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useCreatePollMutation } from '~/lib/api/modules/Polls/hooks/useCreatePollMutation';
import { PollForm } from './PollForm';

export type ICreatePollFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiCreatePollResponseBody,
    inputValues: IUseCreatePollMutationValues,
  ) => void;
  cancelUrl?: string;
  appId: string;
};

export const CreatePollForm: React.FC<ICreatePollFormProps> = (props) => {
  const { sx, onSuccess, cancelUrl, appId } = props;
  const createPollMutation = useCreatePollMutation();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit: SubmitHandler<IPollFormValues> = (values) => {
    if (createPollMutation.isLoading) {
      return;
    }

    return createPollMutation.mutateAsync(
      {
        appId,
        body: {
          active: !values.inactive,
          canUpdate: values.canUpdate,
          description: values.description,
          displayResults: values.displayResults,
          endDate: values.endDate!,
          multipleChoices: values.multipleChoices,
          options: values.options!.split('\n').map((option) => ({
            id: self.crypto.randomUUID(),
            text: option.trim(),
          })),
          requires: values.requires,
          startDate: values.startDate!,
          title: values.title!,
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock draft={disabled} sx={sx} draftOutlineSize="lg">
      <PollForm
        mode="creation"
        cancelUrl={cancelUrl}
        onSubmit={handleSubmit}
        onDisabledStatusChange={setDisabled}
        defaultValues={{
          requires: 'none',
          displayResults: true,
          multipleChoices: false,
          canUpdate: false,
          startDate: new Date().toISOString(),
        }}
        first
      />
    </ContentBlock>
  );
};
